<script lang="ts" setup>
import dayjs from 'dayjs';
import type { Review } from '~/types/Feedback';

const props = defineProps<{ review: Review }>();

const userName = computed(() =>
  props.review.is_anonymous ? 'Анонимный пользователь' : props.review.user.name || 'Покупатель',
);
</script>

<template>
  <div
    :id="`review-${review.id}`"
    class="product-review scroll-m-16 lg:scroll-m-52"
  >
    <div class="flex items-start flex-wrap gap-2">
      <ProductPageFeedbackUserDetailsBlock
        :avatar="review.is_anonymous ? null : review.user.avatar"
        :created-at="review.created_at"
        :is-anonymous="review.is_anonymous"
        :name="userName"
      />

      <div class="flex items-center gap-4">
        <div class="flex gap-1">
          <RatingStars :rating="review.rating" />
        </div>
        {{ review.rating.toFixed(1) }}
      </div>
    </div>

    <div class="product-review__content">
      <div class="product-review__text-blocks">
        <div
          v-if="review.advantages"
          class="product-review__text-blocks-row"
        >
          <span class="product-review__text-blocks-header">Преимущества:</span>
          <span>{{ review.advantages }}</span>
        </div>

        <div
          v-if="review.disadvantages"
          class="product-review__text-blocks-row"
        >
          <span class="product-review__text-blocks-header">Недостатки:</span>
          <span>{{ review.disadvantages }}</span>
        </div>

        <div class="product-review__text-blocks-row">
          <span class="product-review__text-blocks-header">Комментарий:</span>
          <span>{{ review.comment }}</span>
        </div>
      </div>

      <ProductPageFeedbackListItemImagesBlock :images="review.images" />

      <div
        v-if="review.reply"
        class="product-review__content product-review__reply"
      >
        <ProductPageFeedbackUserDetailsBlock
          :created-at="review.reply.updated_at"
          is-manager
        />

        <div class="product-review__text-blocks">
          {{ review.reply.data }}
        </div>
      </div>
    </div>
  </div>
</template>

<style lang="scss" scoped>
.product-review {
  display: flex;
  flex-direction: column;
  gap: 8px;
  padding: 32px 0;

  @include screen-sm {
    gap: 16px;
  }

  &__content {
    display: flex;
    flex-direction: column;
    gap: 16px;
    width: 100%;
  }

  &__reply {
    display: flex;
    margin-top: 16px;
    padding-top: 32px;
    padding-left: 32px;
    border-top: 1px solid $black-20;
  }

  &__text-blocks {
    display: flex;
    flex-direction: column;
    gap: 16px;
    align-items: baseline;
  }

  &__text-blocks-row {
    display: grid;
    grid-template-columns: 1fr;
    gap: 0.5rem;
    font-size: $text-sm;

    @include screen-sm {
      grid-template-columns: 140px 1fr;
    }
  }

  &__text-blocks-header {
    font-weight: bold;
    font-size: $text-sm;

    @include screen-sm {
      font-size: $text-base;
    }
  }
}
</style>
